import Form from './Form';
import SubmitBtn from './SubmitBtn';
import StyleCard from './StyleCard';
import PrefPresetCard from './PrefPresetCard';
import RecommendSpotCard from './RecommendSpotCard';
import Loader from './Loader';

// [note]
// 他案件と比べ内部のパラメータの要件やUIなどがかなり変わってしまったので
// 本案件のみに対応したコードとする。
// なお、データ管理などは行わず、特にデータを送信するサブミット時はDOMの値を直接見にいく。

export default class Aic {
  constructor(opts = {}) {
    this.aicAPIBaseURI = opts.aicAPIBaseURI;
    this.activeClassName = 'is-selected';

    this.app = this;

    this.selector = {
      form: '[data-mp-role="aic-form"]',
      styleCard: '[data-mp-role="aic-style-card"]',
      prefPresetCard: '[data-mp-role="aic-pref-preset-card"]',
      submitBtn: '[data-mp-role="aic-submit-btn"]',
      startSpotSelect: '[data-mp-role="aic-start-spot-select"]',
      durationSelect: '[data-mp-role="aic-duration-select"]',
      startTimeSelect: '[data-mp-role="aic-start-time-select"]',
      daysSelect: '[data-mp-role="aic-days-select"]',
      transportationSelect: '[data-mp-role="aic-transportation-select"]',
      recommendSpotCard: '[data-mp-role="aic-recommend-spot-card"]', // 松本広域独自のおすすめのコンテンツ(スポット)選択
      loader: '[data-mp-role="aic-loader"]',
    };

    this.form = new Form({ elm: document.querySelector(this.selector.form), app: this.app });

    this.styleCards = [];
    document.querySelectorAll(this.selector.styleCard).forEach((card) => {
      this.styleCards.push(new StyleCard({ elm: card, app: this.app }));
    });

    this.prefPresetCards = [];
    document.querySelectorAll(this.selector.prefPresetCard).forEach((card) => {
      this.prefPresetCards.push(new PrefPresetCard({ elm: card, app: this.app }));
    });

    this.recommendSpotCards = [];
    document.querySelectorAll(this.selector.recommendSpotCard).forEach((card) => {
      this.recommendSpotCards.push(new RecommendSpotCard({ elm: card, app: this.app }));
    });

    this.submitBtns = [];
    document.querySelectorAll(this.selector.submitBtn).forEach((submitBtn) => {
      this.submitBtns.push(new SubmitBtn({ elm: submitBtn, app: this.app }));
    });

    this.loader = new Loader({ elm: document.querySelector(this.selector.loader), app: this.app });

    this.init();

    // this.form.node.dataset.state = JSON.stringify(this.store.state);
  }

  init() {
    // 1つ目のカードを選択状態に
    this.styleCards.forEach((card, i) => {
      if (i === 0) card.active();
      if (i !== 0) card.inactive();
    });
  }

  getState() {
    const crStyleCard = document.querySelector(`${this.selector.styleCard}.${this.activeClassName}`);
    const crPrefPresetCard = document.querySelector(`${this.selector.prefPresetCard}.${this.activeClassName}`);

    const crRecommendSpotCards = document.querySelectorAll(`${this.selector.recommendSpotCard}.${this.activeClassName}`);

    return {
      start_spot_id: document.querySelector(this.selector.startSpotSelect).value,
      duration: document.querySelector(this.selector.durationSelect).value,
      start_time: document.querySelector(this.selector.startTimeSelect).value,
      days: document.querySelector(this.selector.daysSelect).value,
      transportation: document.querySelector(this.selector.transportationSelect).value,
      recommendSpotCard: [...crRecommendSpotCards].map(card => card.dataset.value), // 松本広域独自のおすすめコンテンツ(スポット)選択
      tastes: {
        taste1: crStyleCard.dataset.taste1,
        taste2: crStyleCard.dataset.taste2,
        taste3: crStyleCard.dataset.taste3,
        taste4: 0,
      },
      prefs: {
        pref1: crPrefPresetCard.dataset.pref1,
        pref2: crPrefPresetCard.dataset.pref2,
        pref3: crPrefPresetCard.dataset.pref3,
        pref4: crPrefPresetCard.dataset.pref4,
        pref5: crPrefPresetCard.dataset.pref5,
      },
    };
  }

  getQueries() {
    const info = this.getState();
    const urlParams = new URLSearchParams(window.location.search);

    let params = '';

    params += `&start_spot_id=${info.start_spot_id}`;
    params += `&duration=${info.duration}`;
    params += `&start_time=${info.start_time}`;
    params += `&days=${info.days}`;
    params += `&transportation=${info.transportation}`;
    params += `&tastes=${info.tastes.taste1},${info.tastes.taste2},${info.tastes.taste3},${info.tastes.taste4}`;
    params += `&prefs=${info.prefs.pref1},${info.prefs.pref2},${info.prefs.pref3},${info.prefs.pref4},${info.prefs.pref5}`;
    params += `&visit_spot_ids=${info.recommendSpotCard}` // 松本広域独自のおすすめコンテンツ(スポット)選択
    if (urlParams.has('lat') && urlParams.has('lng')) {
      params += `&lat=${urlParams.get('lat')}`
      params += `&lng=${urlParams.get('lng')}`
    }

    return params;
  }

  setGTMParams() {
    this.form.elm.dataset.state = JSON.stringify(this.getState());
  }

  inactivePrefPresetCards() {
    this.prefPresetCards.forEach((cards) => {
      cards.inactive();
    });
  }

  aiRoutePlannerLoaderScroller = {
    targetElmIdName: 'aic_loader',
    yOffset: -300,
    animInterval: 15,
    stepCount: 1,
    stepNum: 20,
    scroll() {
      document.documentElement.scrollTop = 0;
      const targetElmYloc = document.getElementById(this.targetElmIdName).getBoundingClientRect().top;
      const distance = targetElmYloc + this.yOffset;
      window.scrollBy(0, distance);
    },
  };

  aiRoutePlannerSubmitBtnScroller = {
    targetElmIdName: 'aic_search_result',
    yOffset: -300,
    animInterval: 15,
    stepCount: 1,
    stepNum: 20,
    scroll() {
      document.documentElement.scrollTop = 0;
      const targetElmYloc = document.getElementById(this.targetElmIdName).getBoundingClientRect().top;
      const distance = targetElmYloc + this.yOffset;
      window.scrollBy(0, distance);
    },
  };
}
